<template>
    <div style="margin-top:5px; align-self: flex-end; display: flex; justify-content: flex-end; min-height: 36px; overflow: hidden; min-width: 165px;"
         @mouseenter="toggleHovering"
         @mouseleave="toggleHovering" v-if="show">
        <v-btn @click="$emit('click')" color="primary" :rounded="!hovering"
               style="transition: all .4s"
               :class="{'info-btn-hidden': !hovering && !$vuetify.rtl, 'info-btn-hidden-rtl': !hovering && $vuetify.rtl, 'info-btn': hovering && !$vuetify.rtl, 'info-btn-rtl': hovering && $vuetify.rtl}">
            <transition name="fade">
                <v-icon color="white" v-if="!hovering" style="position: absolute;">mdi-information</v-icon>
                <span v-else style="position: absolute;">{{$t('general.instructions')}}</span>
            </transition>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "SectionButton",
        props: {
            show: {type: Boolean, default: false}
        },
        data: () => ({
            hovering: false,
        }),
        methods: {
            toggleHovering() {
                this.hovering = !this.hovering;
            }
        }
    }
</script>

<style scoped>
    .info-btn-hidden {
        transform: translateX(25%);
        display: flex;
        justify-content: flex-start;
    }

    .info-btn-hidden-rtl {
        transform: translateX(-25%);
        display: flex;
        justify-content: flex-start;
    }

    .info-btn {
        transform: translateX(-10%);
        min-width: 150px !important;
    }

    .info-btn-rtl {
        transform: translateX(10%);
        min-width: 150px !important;
    }
</style>